import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, MessageCircle } from 'lucide-react';
import MobileMenu from './MobileMenu';
import Logo from './Logo';
import { trackEvent } from '../utils/analytics';

const PublicNavbar = ({ onDiscoverThemes, onContact }) => {
  const navigate = useNavigate();

  const handleContactUs = () => {
    if (onContact) {
      onContact();
    } else {
      navigate('/contact');
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
    }
  };

  const handleDiscoverThemes = () => {
    trackEvent('Discover Life Themes Button Click', { location: 'public-navbar' });
    if (onDiscoverThemes) {
      onDiscoverThemes();
    } else {
      navigate('/livsteman');
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
    }
  };

  const handleGetStarted = () => {
    trackEvent('Start Chat Button Click', { location: 'public-navbar' });
    navigate('/utforska-livstema');
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
  };

  const handleLogoClick = () => {
    const nextAppUrl = process.env.REACT_APP_NEXT_URL || 'https://yourtherapist.se';
    window.location.href = nextAppUrl;
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-primary border-b border-light shadow-custom-sm">
      <div className="max-w-7xl mx-auto px-custom-6">
        <div className="flex justify-between items-center h-14">
          <Logo 
            onClick={handleLogoClick}
            textColor="text-primary"
            hoverTextColor="hover:text-brand-primary"
          />
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-2">
            <button
              onClick={handleDiscoverThemes}
              className="px-custom-3 py-custom-2 text-sm text-secondary hover:text-brand-primary transition-custom font-medium"
            >
              Utforska livsteman
            </button>
            <button
              onClick={() => {
                trackEvent('Therapists Link Click', { location: 'public-navbar' });
                navigate('/therapists');
                setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
              }}
              className="px-custom-3 py-custom-2 text-sm text-secondary hover:text-brand-primary transition-custom font-medium"
            >
              Våra terapeuter
            </button>
            <button
              onClick={() => navigate('/blog')}
              className="px-custom-3 py-custom-2 text-sm text-secondary hover:text-brand-primary transition-custom font-medium"
            >
              Blog
            </button>
            <button
              onClick={handleContactUs}
              className="px-custom-3 py-custom-2 text-sm text-secondary hover:text-brand-primary transition-custom font-medium"
            >
              Kontakt
            </button>
            <button
              onClick={() => navigate('/therapist-landing')}
              className="px-custom-3 py-custom-2 text-sm text-secondary hover:text-brand-primary transition-custom font-medium"
            >
              För terapeuter
            </button>
            <button
              onClick={() => navigate('/login')}
              className="flex items-center space-x-2 px-custom-3 py-custom-2 text-sm text-secondary hover:text-brand-primary transition-custom font-medium"
            >
              <LogIn className="w-4 h-4" />
              <span>Logga in</span>
            </button>
            <button
              onClick={handleGetStarted}
              className="flex items-center space-x-2 px-custom-4 py-custom-2 bg-brand-primary text-white radius-custom-lg hover:bg-brand-primary-dark transition-custom shadow-custom-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-black"
            >
              <MessageCircle className="w-4 h-4" />
              <span>Kom igång</span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <MobileMenu isLandingPage={true} />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicNavbar;